var _style, _style2, _linearGradient, _linearGradient2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.6142 48.6142",
    style: {
      enableBackground: "new 0 0 48.6142 48.6142"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.fil0 {fill:#FEFEFE}\n    .fil7 {fill:#434242;fill-rule:nonzero}\n    .fil3 {fill:url(#id0)}\n    .fil6 {fill:url(#id1)}\n    .fil4 {fill:url(#id2)}\n    .fil5 {fill:url(#id3)}\n    .fil1 {fill:url(#id4)}\n    .fil2 {fill:url(#id5)}\n")), /*#__PURE__*/React.createElement("defs", null, _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil0 {fill:#FEFEFE}\n    .fil7 {fill:#434242;fill-rule:nonzero}\n    .fil3 {fill:url(#id0)}\n    .fil6 {fill:url(#id1)}\n    .fil4 {fill:url(#id2)}\n    .fil5 {fill:url(#id3)}\n    .fil1 {fill:url(#id4)}\n    .fil2 {fill:url(#id5)}\n  ")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    x1: 38.4227,
    y1: 17.9971,
    x2: 10.5016,
    y2: 17.9971
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0079E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34902,
    style: {
      stopColor: "#00CCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65098,
    style: {
      stopColor: "#00CCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0079E4"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id1",
    gradientUnits: "userSpaceOnUse",
    x1: 48.7221,
    y1: 24.7608,
    x2: 0.0431691,
    y2: 24.7608
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0079E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54902,
    style: {
      stopColor: "#00CCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CCFF"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id2",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id1",
    x1: -0.0787201,
    y1: 18.2421,
    x2: 24.3749,
    y2: 18.2421
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id3",
    gradientUnits: "userSpaceOnUse",
    x1: 24.3749,
    y1: 11.4238,
    x2: 48.8338,
    y2: 11.4238
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A9F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54902,
    style: {
      stopColor: "#00CCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CCFF"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id4",
    gradientUnits: "userSpaceOnUse",
    x1: 24.3749,
    y1: 37.186,
    x2: 48.7499,
    y2: 37.186
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0079E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388235,
    style: {
      stopColor: "#0079E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.670588,
    style: {
      stopColor: "#00CCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CCFF"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "id5",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id1",
    x1: 24.3749,
    y1: 37.1891,
    x2: -0.162519,
    y2: 37.1891
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_251086056"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "_251087568",
    className: "fil0",
    d: "M48.7222 25.7548l-23.7958 13.9856c0,0 -0.494198,0.288705 -1.15463,0l-23.768 -13.9763 0 6.79893c0,0 -0.166328,1.75509 1.69961,3.32548 1.86594,1.5704 21.2277,12.4341 21.2277,12.4341 0,0 1.45945,0.656033 2.77122,0 1.31168,-0.656033 21.3662,-12.4981 21.3662,-12.4981 0,0 1.60751,-1.10384 1.68135,-3.24686l-0.0276399 -6.82276z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_251087208",
    className: "fil1",
    d: "M48.7222 25.7548l-23.7958 13.9856c0,0 -0.215259,0.125698 -0.551529,0.128238l0 8.74525c0.417236,0.00322303 0.880864,-0.0680743 1.3274,-0.291342 1.31168,-0.656033 21.3662,-12.4981 21.3662,-12.4981 0,0 1.60751,-1.10384 1.68135,-3.24686l-0.0276399 -6.82276z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_251087448",
    className: "fil2",
    d: "M24.3749 39.8687c-0.173262,0.00126968 -0.378559,-0.0300816 -0.603097,-0.128238l-23.768 -13.9763 0 6.79893c0,0 -0.166328,1.75509 1.69961,3.32548 1.86594,1.5704 21.2277,12.4341 21.2277,12.4341 0,0 0.635035,0.285385 1.44382,0.291342l0 -8.74525z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_251087136",
    className: "fil3",
    d: "M30.6714 24.2467l-5.64265 -3.3163c0,0 -0.494198,-0.288705 -1.15463,0l-5.58278 3.37158 -6.36802 -3.74467 -1.42175 -0.835937c5.84706,-3.49396 12.5318,-7.37312 12.5318,-7.37312 0,0 1.45945,-0.656033 2.77122,0 0.681427,0.340762 6.84855,3.95153 12.6181,7.34275l-7.75129 4.5557z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_251086896",
    className: "fil0",
    d: "M25.0103 27.5739c0,0 -0.464116,0.304918 -1.15463,0l-15.9006 -9.35001 15.9006 -9.35011c0.660428,-0.288705 1.15463,0 1.15463,0l23.7957 13.9856 0.0277376 -6.82276c-0.0738367,-2.14302 -1.68135,-3.24686 -1.68135,-3.24686 0,0 -20.0546,-11.8421 -21.3663,-12.4981 -1.31168,-0.656033 -2.77112,0 -2.77112,0 0,0 -19.3617,10.8637 -21.2277,12.4341 -1.86604,1.5704 -1.69961,3.32548 -1.69961,3.32548 0,2.20123 -0.000683673,4.38918 -0.0417041,6.59012 -0.00283236,0.159784 20.7946,12.284 22.969,13.5147 0,0 1.50496,0.740125 2.77112,0l12.6084 -7.37019 7.76262 -4.53764 0 0 -7.73439 -4.55717 -13.4124 7.88285z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_251086656",
    className: "fil4",
    d: "M24.3749 27.7065c-0.152068,-0.0100598 -0.326893,-0.0476618 -0.519201,-0.132633l-15.9006 -9.35001 15.9006 -9.35011c0.18928,-0.0828221 0.364984,-0.117982 0.519201,-0.126284l0 -8.74564c-0.768351,0.0240262 -1.35992,0.28978 -1.35992,0.28978 0,0 -19.3617,10.8637 -21.2277,12.4341 -1.86604,1.5704 -1.69961,3.32548 -1.69961,3.32548 0,2.20123 -0.000683673,4.38918 -0.0417041,6.59012 -0.00283236,0.159784 20.7946,12.284 22.969,13.5147 0,0 0.599484,0.294663 1.35992,0.326112l0 -8.77563z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_251086152",
    className: "fil5",
    d: "M24.3749 8.7475c0.383931,-0.0205102 0.635425,0.126284 0.635425,0.126284l23.7957 13.9856 0.0277376 -6.82276c-0.0738367,-2.14302 -1.68135,-3.24686 -1.68135,-3.24686 0,0 -20.0546,-11.8421 -21.3663,-12.4981 -0.476618,-0.238309 -0.972671,-0.303355 -1.4112,-0.28978l0 8.74564z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_251086488",
    className: "fil6",
    d: "M40.9818 30.3064l-2.58731 -1.52059 -12.6084 7.37019c-1.26616,0.740125 -2.77112,0 -2.77112,0 -2.17437,-1.23071 -22.9718,-13.355 -22.969,-13.5147 0.0424854,-2.27917 0.0417041,-4.55873 0.0417041,-6.8381 0.0290073,-0.538051 0.256377,-1.86291 1.69961,-3.0775 0.00312536,-0.00263702 0.00283236,-0.00625072 0.00566472,-0.00898542 0.0418017,-0.0328163 0.0824314,-0.0633862 0.121401,-0.0913192 -0.691682,0.890045 -0.554752,1.69375 -0.159589,1.95247l22.1009 12.996c0.69051,0.304918 1.15463,0 1.15463,0l13.4124 -7.88285 7.73439 4.55717 0 0 2.56504 1.50662 -7.74035 4.5516z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgError);
export default __webpack_public_path__ + "static/media/img-error.fa7c575c74afa05eb21105f1a8ab369c.svg";
export { ForwardRef as ReactComponent };